export default __webpack_public_path__ + "static/media/1277.577c4121.png";